import { ErrorType } from "../../models/ErrorType";

export const StorageService = {
  setPepperStore: (data: any) => {
    sessionStorage.setItem("pepperStore", JSON.stringify(data));
  },
  getPepperStore: () => {
    return JSON.parse(sessionStorage.getItem("pepperStore")!);
  },
  setBankreaderStore: (data: any) => {
    sessionStorage.setItem("bankreaderStore", JSON.stringify(data));
  },
  getBankreaderStore: () => {
    return JSON.parse(sessionStorage.getItem("bankreaderStore")!);
  },
  setError: (error: ErrorType) => {
    sessionStorage.setItem("pepperError", error);
  },
  getError: () => {
    return sessionStorage.getItem("pepperError");
  },
  clearError: () => {
    sessionStorage.removeItem("pepperError");
  },
  deleteStorage: () => {
    sessionStorage.clear();
  },
};
